export default {
  login: "whoroopamgupta",
  id: 56593658,
  node_id: "MDQ6VXNlcjU2NTkzNjU4",
  avatar_url: "https://avatars.githubusercontent.com/u/56593658?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/whoroopamgupta",
  html_url: "https://github.com/whoroopamgupta",
  followers_url: "https://api.github.com/users/whoroopamgupta/followers",
  following_url:
    "https://api.github.com/users/whoroopamgupta/following{/other_user}",
  gists_url: "https://api.github.com/users/whoroopamgupta/gists{/gist_id}",
  starred_url:
    "https://api.github.com/users/whoroopamgupta/starred{/owner}{/repo}",
  subscriptions_url:
    "https://api.github.com/users/whoroopamgupta/subscriptions",
  organizations_url: "https://api.github.com/users/whoroopamgupta/orgs",
  repos_url: "https://api.github.com/users/whoroopamgupta/repos",
  events_url: "https://api.github.com/users/whoroopamgupta/events{/privacy}",
  received_events_url:
    "https://api.github.com/users/whoroopamgupta/received_events",
  type: "User",
  site_admin: false,
  name: "Roopam Badoniya",
  company: null,
  blog: "",
  location: "Indore, India",
  email: null,
  hireable: null,
  bio: "I code Anything that's on my mind.\r\nAnd for that anything, i prefer using React.js and Javascript.",
  twitter_username: "whoroopamgupta",
  public_repos: 5,
  public_gists: 0,
  followers: 0,
  following: 0,
  created_at: "2019-10-15T13:07:02Z",
  updated_at: "2021-08-03T21:00:52Z",
};
